import { RadialGlow1, RadialGlow2, RadialGlow3 } from "./styles";

export const AnimatedGlows = () => (
  <>
    <RadialGlow1 />
    <RadialGlow2 />
    <RadialGlow3 />
  </>
)